var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg63Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178.233,
    height: 180,
    viewBox: "0 0 178.233 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vaav",
    transform: "translate(0 -0.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-1BHK--Balcony-2d",
    transform: "translate(0 0.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M56.05,71.786c0-10.061-4.3-16.822-23.646-16.822-18.186,0-23.643,6.268-23.643,15.5V90.916c0,9.9,4.465,16.822,23.643,16.822,19.348,0,23.646-6.925,23.646-16.822ZM0,22.639C0,11.589,5.786.373,31.91.373c26.285,0,31.742,11.38,31.742,22.266v2.637a1.751,1.751,0,0,1-1.983,1.98H56.874c-1.321,0-1.819-.659-1.819-1.98V23.629C55.055,15.712,51.089,7.8,31.91,7.8c-19.016,0-23.15,7.42-23.15,15.832V56.612c3.144-5.442,10.747-9.071,24.473-9.071,25.3,0,31.576,10.225,31.576,23.254V91.907c0,12.862-6.118,23.252-32.406,23.252C6.284,115.16,0,104.769,0,91.907Z",
    transform: "translate(0 -0.373)",
    fill: "#8dc541",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M61.307,50.547c19.182,0,22.982-6.1,22.982-16.162v-9.9C84.289,14.595,79.824,8,61.473,8s-22.981,6.6-22.981,16.493v2.144a1.752,1.752,0,0,1-1.985,1.978H31.876c-1.487,0-1.983-.659-1.983-1.978V23.5C29.893,10.636,36.177.576,61.637.576c25.3,0,31.412,9.9,31.412,22.759v12.2c0,9.4-2.81,15.832-14.712,18.635,12.9,2.8,15.708,9.568,15.708,19.132V92.6c0,12.865-6.78,22.759-32.408,22.759S29.066,105.3,29.066,92.436V89.3a1.749,1.749,0,0,1,1.983-1.977h4.793c1.323,0,1.819.659,1.819,1.977v2.146c0,9.894,5.295,16.493,23.975,16.493,18.518,0,23.645-6.6,23.645-16.493V74.3c0-10.061-3.636-16.327-22.982-16.327H46.923c-1.489,0-1.987-.5-1.987-1.815V52.527c0-1.321.5-1.98,1.987-1.98Z",
    transform: "translate(58.063 -0.575)",
    fill: "#8dc541",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M68.367,7.812c0-2.161-1.288-3.855-5.914-3.855-4.684,0-5.971,1.694-5.971,3.855v5.723c0,2.22,1.287,3.855,5.971,3.855,4.626,0,5.914-1.635,5.914-3.855Zm-14.843-.84c0-3.551,2.046-6.044,8.938-6.044s8.862,2.492,8.862,6.044v7.4c0,3.551-1.97,6.044-8.862,6.044s-8.938-2.492-8.938-6.044Z",
    transform: "translate(106.909 0.129)",
    fill: "#8dc541",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M.647,86.905c-.412,0-.647-.235-.647-.7v-38.5A.625.625,0,0,1,.707,47h20.06c.47,0,.706.176.706.705V49c0,.526-.235.7-.706.7H3.12V64.605H19.706c.474,0,.709.176.709.7v1.233a.624.624,0,0,1-.709.7H3.12v16.96H21.473c.47,0,.707.176.707.7V86.2c0,.528-.237.7-.707.7Z",
    transform: "translate(0 92.157)",
    fill: "#55b849",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M28.262,56.566c-.588-1.937-1.352-5.635-1.472-6.22-.061.411-.764,4.165-1.354,6.1l-5,15.844H33.143ZM27.791,47a.83.83,0,0,1,.88.705L40.616,86.2c.176.469-.061.7-.529.7H38.263a.777.777,0,0,1-.823-.7L33.848,74.816H19.669L16.2,86.2a.778.778,0,0,1-.823.7H13.671c-.47,0-.707-.235-.529-.7l11.943-38.5A.831.831,0,0,1,25.967,47Z",
    transform: "translate(26.131 92.157)",
    fill: "#55b849",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M49.305,55.627c0-3.52-1.94-5.987-8.765-5.987s-8.767,2.466-8.767,5.987V57.8a5.208,5.208,0,0,0,3.707,4.99L46.775,67.07c2.941,1.114,5.881,3.344,5.881,7.336V79.57c0,4.576-2.82,8.274-12.177,8.274s-12.236-3.7-12.236-8.274V76.518c0-.53.235-.764.705-.764h1.707c.47,0,.705.235.705.764v2.7c0,3.52,2.177,5.985,9.061,5.985,6.943,0,9.178-2.465,9.178-5.985V75.051c0-3.169-2.59-4.578-4.883-5.457L33.774,65.369a7.522,7.522,0,0,1-5.06-6.925V55.275C28.714,50.7,31.3,47,40.54,47c9.177,0,11.824,3.7,11.824,8.276v2.874c0,.471-.176.705-.706.705H49.952c-.47,0-.647-.235-.647-.705Z",
    transform: "translate(56.415 92.156)",
    fill: "#55b849",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M67.289,47c.47,0,.706.176.706.705V49c0,.526-.235.7-.706.7H56.584V86.2c0,.469-.178.7-.647.7H54.17c-.531,0-.706-.235-.706-.7V49.7H42.818c-.533,0-.709-.176-.709-.7V47.705c0-.53.176-.705.709-.705Z",
    transform: "translate(84.112 92.157)",
    fill: "#55b849",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg63Logo);
export default __webpack_public_path__ + "static/media/63LOGO.48868d9742e94ff133c9ff3ca3ac9af2.svg";
export { ForwardRef as ReactComponent };